import React, { Fragment } from 'react'
import { Paper, Typography } from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import IconButton from '@mui/material/IconButton';
import { v4 as uuidv4 } from 'uuid';
import Removebutton from '@mui/icons-material/RemoveCircle';
import { useStateIfMounted } from 'use-state-if-mounted';
import { useDispatch, useSelector } from 'react-redux';
import {
    guardarCambiosFC_08Solicitud, //agregarFC_08AnexoCertificado,
    guardarCambiosFC_08Certificado, actualizarFC_08PaginaActiva, actualizarFC_08Estatus,
    resetDataFC_08, agregarMapFC_08Accion, obtenerIdCliente,
    actualizarFC_08Solicitud, actualizarFC_08MapSolicitud,
    generarDocumentosFC_08, actualizarFC_08SolicitudFomulario
} from '../../../redux/DucksAtencionACliente/FC_08AtencionAClienteDucks';
import { AcualizarFormatoAccion } from '../../../redux/AtencionAClienteDucks'
import { withRouter } from 'react-router-dom'
import { host } from '../../../configuraciones'
import moment from 'moment'
import SaveIcon from '@mui/icons-material/Save';
import FormatClearIcon from '@mui/icons-material/FormatClear';
import ToolBarPaginas from '../../App/ToolBarPaginas';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { actualizarLoadingApp_false, actualizarLoadingApp_true } from '../../../redux/AppDucks';
import BotonDescargarArchivos from '../../App/BotonDescargarArchivos';
import TablaAtencionACliente from '../../App/TablaAtencionACliente';
import PaginacionAtencionAClientesComponent from '../../App/PaginacionAtencionAClientesComponent';
import TablaDocumentacion from '../../App/TablaDocumentacion';
import { obtenerClienteByIdLogin } from '../../../redux/DucksBeneficiario/ClienteDucks';
import { obtenerTodasLasSolicitudesEjecuctivoWithStatusEnviado } from '../../../redux/DucksAtencionACliente/AtencionAClienteDucks';
import { obtenerTodasLasSolicitudesWithStatusEnviado } from '../../../redux/AtencionAClienteDucks'
import { DataGrid, useGridApiRef } from '@mui/x-data-grid';
import estilos from './AtencionAClientesFC_08Component.module.css';
import Tooltip from '@mui/material/Tooltip';
import ModalDetalleMotivos from './ModalDetalleMotivos'
const { useState, useEffect, useRef } = React;
import FormularioDocumentacionFC_08 from '../../UsuarioAtencionACliente/FormularioFC08/FormularioDocumentacionFC_08';
import { crearMetricas } from '../../../redux/DuckMetricas/MetricasDuck';
import dayjs from 'dayjs';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
const styleDevolver = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
const styleCorrecto = {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(90%, -35%)',
    width: 350,
    height: 450,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 3,
    p: 3,
    // background:'black',
    opacity: 1,
    'overflowY': 'scroll',
};
const styleIncorrecto = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(100%, -10%)',
    width: 330,
    height: 220,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 0,
    p: 3,
    'overflowY': 'scroll',
};
const styleParaModalDeDocumentos = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 1000,
    height: 600,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    color: 'black',
    p: 4,
    'overflowY': 'scroll',
};
function FC_08Component(props) {

    const dispatch = useDispatch()
    const usuario = useSelector(store => store.Usuario)
    const tipoUsuario = useSelector(store => store.Usuario.tipoUsuario)
    const solicitud = useSelector(store => store.FC_08SolicitudAtencionACliente.data)
    let fc_08Map = useSelector(store => store.FC_08SolicitudAtencionACliente.fc_08Map)
    let fc_08CertificadosMap = useSelector(store => store.FC_08SolicitudAtencionACliente.certificadosMap)
    let filesExportacionMap = useSelector(store => store.FC_08SolicitudAtencionACliente.filesExportacionMap)
    let filesGranelMap = useSelector(store => store.FC_08SolicitudAtencionACliente.filesGranelMap)
    const currentUser = useSelector(store => store.Usuario.data)
    const dataUser = useSelector(store => store.Usuario.user)
    var fechaHoy = moment().format('YYYY-MM-DD')
    const idUsuario = usuario.data.user[0].id
    const idlogin = idUsuario

    const [paginaActiva, setPaginaActiva] = useStateIfMounted(1)
    const [paginas, setPaginas] = useStateIfMounted([1, 2, 3, 4])
    const modoVerDetalle = useSelector(store => store.FC_08SolicitudAtencionACliente.modoVerDetalle)
    const [nombresParaPaginas, setNombresParaPaginas] = useStateIfMounted(['Datos solicitante', 'Certificados', 'Documentación'])
    const cambiarPagina = (pagina) => {
        setPaginaActiva(pagina)
    }

    let pagina1 = []
    pagina1.push(
        {
            id: uuidv4(), Campo: 'Tipo de instalación', valor: solicitud.tipoinstalacion, idfc08_renvacioncertificado: solicitud.idfc08_renvacioncertificado,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_08Map) && JSON.stringify([]) !== JSON.stringify(fc_08Map) ? fc_08Map?.tipoinstalacion : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_08Map) && JSON.stringify([]) !== JSON.stringify(fc_08Map) ? !fc_08Map?.tipoinstalacioncheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_08Map) && JSON.stringify([]) !== JSON.stringify(fc_08Map) ? fc_08Map?.tipoinstalacioncheck : false,
        },
        {
            id: uuidv4(), Campo: 'Nombre del responsable', valor: solicitud.nombreresponsable, idfc08_renvacioncertificado: solicitud.idfc08_renvacioncertificado,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_08Map) && JSON.stringify([]) !== JSON.stringify(fc_08Map) ? fc_08Map?.nombreresponsable : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_08Map) && JSON.stringify([]) !== JSON.stringify(fc_08Map) ? !fc_08Map?.nombreresponsablecheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_08Map) && JSON.stringify([]) !== JSON.stringify(fc_08Map) ? fc_08Map?.nombreresponsablecheck : false,
        },
        {
            id: uuidv4(), Campo: 'Correo electrónico', valor: solicitud.correoelectronico, idfc08_renvacioncertificado: solicitud.idfc08_renvacioncertificado,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_08Map) && JSON.stringify([]) !== JSON.stringify(fc_08Map) ? fc_08Map?.correoelectronico : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_08Map) && JSON.stringify([]) !== JSON.stringify(fc_08Map) ? !fc_08Map?.correoelectronicocheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_08Map) && JSON.stringify([]) !== JSON.stringify(fc_08Map) ? fc_08Map?.correoelectronicocheck : false,
        },
        {
            id: uuidv4(), Campo: 'Teléfono', valor: solicitud.telefono, idfc08_renvacioncertificado: solicitud.idfc08_renvacioncertificado,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_08Map) && JSON.stringify([]) !== JSON.stringify(fc_08Map) ? fc_08Map?.telefono : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_08Map) && JSON.stringify([]) !== JSON.stringify(fc_08Map) ? !fc_08Map?.telefonocheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_08Map) && JSON.stringify([]) !== JSON.stringify(fc_08Map) ? fc_08Map?.telefonocheck : false,
        },
        {
            id: uuidv4(), Campo: 'Domicilio completo', valor: solicitud.domicilio, idfc08_renvacioncertificado: solicitud.idfc08_renvacioncertificado,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_08Map) && JSON.stringify([]) !== JSON.stringify(fc_08Map) ? fc_08Map?.domicilio : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_08Map) && JSON.stringify([]) !== JSON.stringify(fc_08Map) ? !fc_08Map?.domiciliocheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_08Map) && JSON.stringify([]) !== JSON.stringify(fc_08Map) ? fc_08Map?.domiciliocheck : false,
        },
    )
    let [rowspagina1, setRowsPagina1] = React.useState(pagina1)
    let pagina2 = []
    let pagina4 = []

    for (const i in solicitud.fc_08_anexocertificados) {
        const { ...producto } = solicitud.fc_08_anexocertificados[i]
        let filtro = fc_08CertificadosMap?.filter(anexo => anexo?.idfc08_anexorenovacion === producto?.idfc08_anexorenovacion)
        pagina2.push(
            {
                id: uuidv4(), idfc08_anexorenovacion: producto.idfc08_anexorenovacion,
                idfc08_anexorenovacionmap: filtro?.[0]?.idfc08_anexorenovacionmap ? filtro?.[0]?.idfc08_anexorenovacionmap : '',
                tipocertificado: producto.tipocertificado, numerocertificado: producto.numerocertificado,
                vencimientocertificado: producto.vencimientocertificado, cambioaduana: producto.cambioaduana,
                especificaraduana: producto.especificaraduana, cambiocatidad: producto.cambiocatidad,
                especificarcantidad: producto.especificarcantidad, cambiodestinatario: producto.cambiodestinatario,
                especificardestinatario: producto.especificardestinatario, domicilioimportador: producto.domicilioimportador,
                especificardomicilio: producto.especificardomicilio, otros: producto.otros, especificarotros: producto.especificarotros,
                observaciones: filtro?.[0] ? filtro?.[0].certificado : '',
                correcto: filtro?.[0] ? !filtro?.[0].certificadocheck : false,
                incorrecto: filtro?.[0] ? filtro?.[0].certificadocheck : false,
            }
        )

        pagina4.push({ id: uuidv4(), nameDoc: 'DOCUMENTACION DE CERTIFICADO: ' + producto.numerocertificado })
        for (const i in producto.fc_08archivoscertificados) {

            const filtroMapGranel = filesGranelMap?.filter(anexo => anexo?.idfc_08archivoscertificados === producto.fc_08archivoscertificados?.[i]?.idfc_08archivoscertificados)
            let nameid = producto.fc_08archivoscertificados?.[i]?.nameid
            let nameDoc = ''
            if ((nameid).includes('DGOD')) nameDoc = 'Otro Documento'
            if ((nameid).includes('DGCN')) nameDoc = 'Certificado NOM a renovar '
            if ((nameid).includes('DGAL')) nameDoc = 'Análisis de laboratorio'
            if ((nameid).includes('DEFP')) nameDoc = 'Factura del producto'
            if ((nameid).includes('DECN')) nameDoc = 'Certificado NOM a renovar'
            if ((nameid).includes('DEOD')) nameDoc = 'Otro Documento'
            pagina4.push({
                id: uuidv4(),
                observaciones: filtroMapGranel?.[0]?.observacion ? filtroMapGranel?.[0]?.observacion : '',
                correcto: filtroMapGranel?.[0] ? !filtroMapGranel?.[0]?.estatuscheck : false,
                incorrecto: filtroMapGranel?.[0] ? filtroMapGranel?.[0]?.estatuscheck : false,
                fechaInicio: producto.fc_08archivoscertificados?.[i]?.fechainicio ? producto.fc_08archivoscertificados?.[i]?.fechainicio : '',
                fechaTermino: producto.fc_08archivoscertificados?.[i]?.fechafin ? producto.fc_08archivoscertificados?.[i]?.fechafin : '',
                estatus: producto.fc_08archivoscertificados?.[i]?.estatus ? producto.fc_08archivoscertificados?.[i]?.estatus : 'Agregar',
                idMap: filtroMapGranel?.[0]?.idfc_08archivoscertificadosmap ? filtroMapGranel?.[0]?.idfc_08archivoscertificadosmap : '',
                idfc_08archivoscertificados: producto.fc_08archivoscertificados?.[i]?.idfc_08archivoscertificados,
                tabla: 'fc_08archivoscertificados', nombreId: 'idfc08_anexorenovacion', idSolicitud: producto.idfc08_anexorenovacion,
                nameid: nameid, nameDoc: nameDoc
            })
        }
    }
    let [rowspagina2, setRowsPagina2] = React.useState(pagina2)
    let [rowspagina4, setRowsPagina4] = React.useState(pagina4)
    let pagina3 = []

    let [rowspagina3, setRowsPagina3] = React.useState(pagina3)
    const handdleEditPrev = (objectProducto) => {
        const filtroGeneral = rowspagina1.findIndex(anexo => anexo.id === objectProducto.id)
        const filtroCertificado = rowspagina2.findIndex(anexo => anexo.id === objectProducto.id)
        const filtroDocumentacion = rowspagina4.findIndex(anexo => anexo.id === objectProducto.id)
        if (filtroGeneral !== -1) {
            rowspagina1[filtroGeneral].valor = objectProducto.valor
            rowspagina1[filtroGeneral].correcto = objectProducto.correcto
            rowspagina1[filtroGeneral].incorrecto = objectProducto.incorrecto
            rowspagina1[filtroGeneral].observaciones = objectProducto.observaciones
        }
        if (filtroCertificado !== -1) {
            rowspagina2[filtroCertificado].numerocertificado = objectProducto.numerocertificado
            rowspagina2[filtroCertificado].correcto = objectProducto.correcto
            rowspagina2[filtroCertificado].incorrecto = objectProducto.incorrecto
            rowspagina2[filtroCertificado].observaciones = objectProducto.observaciones
        }

        if (filtroDocumentacion !== -1) {
            rowspagina4[filtroDocumentacion].valor = objectProducto.valor
            rowspagina4[filtroDocumentacion].correcto = objectProducto.correcto
            rowspagina4[filtroDocumentacion].incorrecto = objectProducto.incorrecto
            rowspagina4[filtroDocumentacion].observaciones = objectProducto.observaciones
        }
    }

    let columns = [
        {
            field: 'tipocertificado', headerName: 'Tipo certificado', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 300,
            renderCell: (params) =>
            (
                <div>
                    <Tooltip title={`${params.row.tipocertificado == 'Exportacion' ? 'Exportación' : params.row.tipocertificado == 'Exportacion promocion' ? 'Exportación promoción' : params.row.tipocertificado}`} arrow>
                        <label>{`${params.row.tipocertificado == 'Exportacion' ? 'Exportación' : params.row.tipocertificado == 'Exportacion promocion' ? 'Exportación promoción' : params.row.tipocertificado}`}</label>
                    </Tooltip>
                </div>
            )
        },
        { field: 'numerocertificado', headerName: 'Número de certificado', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 370, },
        {
            field: 'motivo', headerName: 'Motivos', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 150,
            renderCell: (params) => (
                <Fragment>
                    <Fragment>
                        <button className={'btn btn-secondary ms-1'} onClick={() => { setDataDetalle(params.row), setDetalleMotivo(true) }} >Detalle</button>
                    </Fragment>
                </Fragment>
            )
        },
        {
            field: 'accion', headerName: 'Acción', headerClassName: estilos.headerSolicitudes, headerAlign: 'center', width: 200,
            renderCell: (params) => (

                <Fragment>
                    <Fragment>
                        <button className={params.row.correcto ? ('btn btn-success ms-1') : ('btn btn-outline-success ms-1')} onClick={() => handleOpenModalCorrecto(params)}>✓</button>
                        <button className={params.row.incorrecto ? ('btn btn-danger ms-2') : ('btn btn-outline-danger ms-2')} onClick={() => handleOpenModalIncorrecto(params)}>X</button>
                    </Fragment>
                </Fragment>

            )
        },
    ]
    const [campo, setCampo] = React.useState('')
    const [valor, setValor] = React.useState('')
    const [observaciones, setObservaciones] = React.useState('')
    const [correcto, setCorrecto] = React.useState('')
    const [incorrecto, setIncorrecto] = React.useState('')
    const [id, setId] = React.useState('')
    const [rowSeleccionada, setRowSeleccionada] = React.useState(false)
    const [openModalCorrecto, setOpenModalCorrecto] = React.useState(false);
    const [documentacion, setDocumentacion] = React.useState('')
    const [estadoVigencia, setEstadoVigencia] = React.useState('')
    const [fechaInicio, setFechaInicio] = React.useState('')
    const [fechaTermino, setFechaTermino] = React.useState('')
    const [vigencia, setVigencia] = React.useState(false);
    const handleOpenModalCorrecto = (params) => {
        setId(params.row.id)
        setCorrecto(true)
        setIncorrecto(false)
        setCampo(params.row.numerocertificado)
        setObservaciones(params.row.observaciones)
        setOpenModalCorrecto(true)
        setValor(params.row.valor)
        setFechaInicio((params.row.fechaInicio !== null && params.row.fechaInicio !== '') ? (params.row.fechaInicio) : '')
        setFechaTermino((params.row.fechaTermino !== null && params.row.fechaTermino !== '') ? (params.row.fechaTermino) : '')
        setEstadoVigencia((params.row.estatus !== null && params.row.estatus !== undefined) ? params.row.estatus : 'Agregar')
        if (params.row.tabla) {
            setRowSeleccionada(true)
            setValor(params.row.nameDoc)
        }
    }
    const handleCloseModalCorrecto = () => {
        setFechaInicio('')
        setFechaTermino('')
        setEstadoVigencia('')
        setOpenModalCorrecto(false)
        setVigencia(false)
        setRowSeleccionada(false)
    }
    const modalComponentCorrecto = () => {
        return (
            <Modal
                open={openModalCorrecto}
                onClose={handleCloseModalCorrecto}
                hideBackdrop={true}

            >
                <Box sx={styleCorrecto}>
                    <Typography id="modal-modal-description" component="h2" sx={{ color: 'black' }}>
                        <div className="form-floating mb-3" color='black'>
                            <textarea className="form-control" id="exampleFormControlTextarea1" rows="3" style={{ height: "80px" }} value={campo} onChange={e => setCampo(e.target.value)} />
                            {/* <input type="text" className={`form-control `} id="floatinginput" placeholder='Campo' value={valor} onChange={e => setValor(e.target.value)} /> */}
                            <label htmlFor="floatingInput">Campo</label>
                        </div>
                        <div className="form-floating mb-3">
                            <textarea className="form-control" id="exampleFormControlTextarea1" rows="3" value={observaciones} onChange={e => setObservaciones(e.target.value)}></textarea>
                            <label htmlFor="floatingInput">Observaciones</label>
                        </div>
                        <br /><br />

                    </Typography>
                    <br />
                    <div className='row'>
                        <div className='col-md-6'>
                            <button className='btn btn-outline-success' onClick={() => { botonGuardar() }}>GUARDAR</button>
                        </div>
                        <div className={`${estilos.botonCancelarModal} col-md-2`}>
                            <button className='btn btn-outline-danger' onClick={() => { handleCloseModalCorrecto() }}>CANCELAR</button>
                        </div>
                    </div>
                </Box>
            </Modal>
        )
    }
    const [openModalIncorrecto, setOpenModalIncorrecto] = React.useState(false);
    const handleOpenModalIncorrecto = (params) => {
        setId(params.row.id)
        setIncorrecto(true)
        setCorrecto(false)
        setCampo(params.row.Campo)
        setValor(params.row.valor)
        setObservaciones(params.row.observaciones)
        setOpenModalIncorrecto(true)
    }
    const handleCloseModalIncorrecto = () => {
        setOpenModalIncorrecto(false)

    }
    const modalComponentIncorrecto = () => {
        return (
            <Modal
                open={openModalIncorrecto}
                onClose={handleCloseModalIncorrecto}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                hideBackdrop={true}
            >
                <Box sx={styleIncorrecto}>
                    <Typography id="modal-modal-description" component="h2" sx={{ mt: 0 }} className='text-center'>
                        <label className='text-center'>Observaciones</label>
                        <textarea className="form-control" id="exampleFormControlTextarea1" rows="3"
                            value={observaciones} onChange={e => setObservaciones(e.target.value)}></textarea>
                    </Typography>
                    <br />
                    <div className='row'>
                        <div className='col-md-6'>
                            <button className='btn btn-outline-success' onClick={() => { botonGuardar() }}>GUARDAR</button>
                        </div>
                        <div className={`${estilos.botonCancelarModal} col-md-2`}>
                            <button className='btn btn-outline-danger' onClick={() => { handleCloseModalIncorrecto() }}>CANCELAR</button>
                        </div>
                    </div>
                </Box>
            </Modal>
        )
    }
    const botonGuardar = () => {
        let datos = { id: id, campo: campo, correcto: correcto, incorrecto: incorrecto, observaciones: observaciones, valor: valor, numerocertificado: campo }
        handdleEditPrev(datos)
        handleCloseModalCorrecto(true)
        handleCloseModalIncorrecto(true)
    }
    const botonRegresar = async () => {
        props.history.push('/AtencionAClientesComponent')
        await dispatch(resetDataFC_08())
    }
    const botonDevolverSolicitud = async () => {
        await dispatch(actualizarLoadingApp_true())
        if (JSON.stringify({}) === JSON.stringify(fc_08Map) || JSON.stringify([]) === JSON.stringify(fc_08Map) || fc_08Map === null) {
            await agregarMapYActualizarFC_08()
            const idSolicitud = solicitud.idfc08_renvacioncertificado
            const estatusNuevo = 5
            const idCliente = null //Se necesita obtener del cliente, a traves del login 
            const tablaFC_08 = 3
            const tabla = tablaFC_08
            await dispatch(actualizarFC_08Estatus(
                { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: solicitud.folio } }
            ))
        } else {
            await actualizarMapYActualizarFC_08()
            const idSolicitud = solicitud.idfc08_renvacioncertificado
            const estatusNuevo = 5
            const idCliente = null //Se necesita obtener del cliente, a traves del login 
            const tablaFC_08 = 3
            const tabla = tablaFC_08
            await dispatch(actualizarFC_08Estatus(
                { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: solicitud.folio } }
            ))
        }
        await dispatch(actualizarLoadingApp_false())
        props.history.push('/AtencionAClientesComponent')
    }
    const agregarMapYActualizarFC_08 = async () => {
        let principal = []
        const fechaHoy = moment().format('YYYY-MM-DD')
        let fechaSolicitudAceptada = new Date(fechaHoy).toISOString()

        principal.push({
            idfc08_renvacioncertificado: rowspagina1[0].idfc08_renvacioncertificado,
            nombreresponsable: rowspagina1[1].valor, correoelectronico: rowspagina1[2].valor,
            telefono: rowspagina1[3].valor, domicilio: rowspagina1[4].valor,
            fechasolicitud: fechaSolicitudAceptada
        })


        let principalMap = []
        principalMap.push({
            tipoinstalacion: rowspagina1[0].observaciones,
            nombreresponsable: rowspagina1[1].observaciones,
            correoelectronico: rowspagina1[2].observaciones,
            telefono: rowspagina1[3].observaciones,
            domicilio: rowspagina1[4].observaciones,

            tipoinstalacioncheck: rowspagina1[0].incorrecto,
            nombreresponsablecheck: rowspagina1[1].incorrecto,
            correoelectronicocheck: rowspagina1[2].incorrecto,
            telefonocheck: rowspagina1[3].incorrecto,
            domiciliocheck: rowspagina1[4].incorrecto,
            idfc08_renvacioncertificado: solicitud.idfc08_renvacioncertificado,
        })

        let solicitudMap = {}
        for (const i in principalMap) {
            solicitudMap = Object.assign(solicitudMap, principalMap[i])
        }
        let certificadosMap = []
        for (const certificado of rowspagina2) {
            certificadosMap.push({ certificado: certificado.observaciones, certificadocheck: certificado.incorrecto, idfc08_anexorenovacion: certificado.idfc08_anexorenovacion })
        }

        let archivosExportacionMap = []
        let archivosGranelMap = []
        for (const anexo in rowspagina4) {
            let nameid = rowspagina4[anexo]?.nameid?.substring(0, 4)
            if (nameid === "DGAL" || nameid === "DGCN" || nameid === "DGOD" ||
                nameid === "DEFP" || nameid === "DECN" || nameid === "DEOD") {
                archivosGranelMap.push({
                    estatuscheck: rowspagina4[anexo]?.incorrecto, observacion: rowspagina4[anexo]?.observaciones,
                    idfc_08archivoscertificados: rowspagina4[anexo]?.idfc_08archivoscertificados,
                })
            }
        }
        let archivosGranel = []
        let archivosExportacion = []
        for (const anexo in rowspagina4) {
            let nameid = rowspagina4[anexo]?.nameid?.substring(0, 4)
            if (nameid === "DGAL" || nameid === "DGCN" || nameid === "DGOD" ||
                nameid === "DEFP" || nameid === "DECN" || nameid === "DEOD") {
                let fechaInicio = ''
                let fechaFin = ''
                if (rowspagina4[anexo]?.fechaInicio.length > 0) fechaInicio = new Date(rowspagina4[anexo]?.fechaInicio).toISOString()
                else fechaInicio = null
                if (rowspagina4[anexo]?.fechaTermino.length > 0) fechaFin = new Date(rowspagina4[anexo]?.fechaTermino).toISOString()
                else fechaFin = null
                archivosGranel.push({
                    fechainicio: fechaInicio, fechafin: fechaFin, idfc_08archivoscertificados: rowspagina4[anexo]?.idfc_08archivoscertificados
                })
            }
        }
        let formato = { solicitud: principal[0], archivosExportacion: archivosExportacion, archivosGranel: archivosGranel, rowspagina2 }
        let formatoMap = {
            solicitud: solicitudMap, certificadosMap: certificadosMap,
            archivosExportacionMap: archivosExportacionMap, archivosGranelMap: archivosGranelMap
        }
        await dispatch(agregarMapFC_08Accion(formatoMap))
        await dispatch(actualizarFC_08Solicitud(formato))
        return
    }
    const actualizarMapYActualizarFC_08 = async () => {
        let principal = []
        const fechaHoy = moment().format('YYYY-MM-DD')
        let fechaSolicitudAceptada = new Date(fechaHoy).toISOString()

        principal.push({
            idfc08_renvacioncertificado: rowspagina1[0].idfc08_renvacioncertificado,
            nombreresponsable: rowspagina1[1].valor, correoelectronico: rowspagina1[2].valor,
            telefono: rowspagina1[3].valor, domicilio: rowspagina1[4].valor,
            fechasolicitud: fechaSolicitudAceptada
        })

        let principalMap = []
        principalMap.push({
            idfc08_renvacioncertificadomap: fc_08Map.idfc08_renvacioncertificadomap,
            tipoinstalacion: rowspagina1[0].observaciones,
            nombreresponsable: rowspagina1[1].observaciones,
            correoelectronico: rowspagina1[2].observaciones,
            telefono: rowspagina1[3].observaciones,
            domicilio: rowspagina1[4].observaciones,

            tipoinstalacioncheck: rowspagina1[0].incorrecto,
            nombreresponsablecheck: rowspagina1[1].incorrecto,
            correoelectronicocheck: rowspagina1[2].incorrecto,
            telefonocheck: rowspagina1[3].incorrecto,
            domiciliocheck: rowspagina1[4].incorrecto,
            idfc08_renvacioncertificado: solicitud.idfc08_renvacioncertificado,
        })
        let solicitudMap = {}
        for (const i in principalMap) {
            solicitudMap = Object.assign(solicitudMap, principalMap[i])
        }
        let certificadosMap = []
        for (const certificado of rowspagina2) {
            certificadosMap.push({
                certificado: certificado.observaciones, certificadocheck: certificado.incorrecto, idfc08_anexorenovacion: certificado.idfc08_anexorenovacion,
                idfc08_anexorenovacionmap: certificado.idfc08_anexorenovacionmap
            })
        }
        let archivosExportacionMap = []
        let archivosGranelMap = []
        for (const anexo in rowspagina4) {
            let nameid = rowspagina4[anexo]?.nameid?.substring(0, 4)
            if (nameid === "DGAL" || nameid === "DGCN" || nameid === "DGOD" ||
                nameid === "DEFP" || nameid === "DECN" || nameid === "DEOD") {
                archivosGranelMap.push({
                    estatuscheck: rowspagina4[anexo]?.incorrecto, observacion: rowspagina4[anexo]?.observaciones,
                    idfc_08archivoscertificados: rowspagina4[anexo]?.idfc_08archivoscertificados, idfc_08archivoscertificadosmap: rowspagina4[anexo]?.idMap
                })
            }
        }
        let archivosGranel = []
        let archivosExportacion = []
        for (const anexo in rowspagina4) {
            let nameid = rowspagina4[anexo]?.nameid?.substring(0, 4)
            if (nameid === "DGAL" || nameid === "DGCN" || nameid === "DGOD" ||
                nameid === "DEFP" || nameid === "DECN" || nameid === "DEOD") {
                let fechaInicio = ''
                let fechaFin = ''
                if (rowspagina4[anexo]?.fechaInicio.length > 0) fechaInicio = new Date(rowspagina4[anexo]?.fechaInicio).toISOString()
                else fechaInicio = null
                if (rowspagina4[anexo]?.fechaTermino.length > 0) fechaFin = new Date(rowspagina4[anexo]?.fechaTermino).toISOString()
                else fechaFin = null
                archivosGranel.push({
                    fechainicio: fechaInicio, fechafin: fechaFin, idfc_08archivoscertificados: rowspagina4[anexo]?.idfc_08archivoscertificados
                })
            }
        }
        let formato = { solicitud: principal[0], archivosExportacion: archivosExportacion, archivosGranel: archivosGranel, rowspagina2 }
        let formatoMap = {
            solicitud: solicitudMap, certificadosMap: certificadosMap,
            archivosExportacionMap: archivosExportacionMap, archivosGranelMap: archivosGranelMap
        }
        await dispatch(actualizarFC_08MapSolicitud(formatoMap))
        await dispatch(actualizarFC_08Solicitud(formato))
        return
    }
    const [openModalAceptar, setOpenModalAceptar] = React.useState(false);
    const [dataModal, setDataModal] = React.useState('')
    const handleOpenModalAceptar = () => setOpenModalAceptar(true);
    const handleCloseModalAceptar = () => setOpenModalAceptar(false);
    const modalComponentAceptar = () => {
        return (
            <Modal
                open={openModalAceptar}
                onClose={handleCloseModalAceptar}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={styleParaModalDeDocumentos}>
                    <Typography id="modal-modal-title" variant="h6" component="h2" color="black !important" align='center'>
                        Para finalizar el trámite ingrese los siguientes datos
                    </Typography>
                    <FormularioDocumentacionFC_08
                        functionAcept={botonAceptarSolicitud}
                    ></FormularioDocumentacionFC_08>
                    <br />
                </Box>
            </Modal>
        )
    }
    const botonAceptarSolicitud = async (dataForm) => {
        await dispatch(actualizarLoadingApp_true())
        if (JSON.stringify({}) === JSON.stringify(fc_08Map) || JSON.stringify([]) === JSON.stringify(fc_08Map) || fc_08Map === null) {
            await agregarMapYActualizarFC_08()
        } else {
            await actualizarMapYActualizarFC_08()
        }
        let dataMetricas = {
            estatus_procedencia: "Solicitudes Recibidas Procedentes",
            id_solicitud: "4", id_usuario: dataUser?.[0].idlogin,
            motivo: "Cargado automatico del sistema",
            fecha: moment().format('YYYY-MM-DD HH:mm:ss'),
            numero_cliente: solicitud?.numerocliente,
            numero_solicitud: dataForm?.numeroSolicitud, origen: "Sistema"
        }
        await dispatch(crearMetricas(dataMetricas))
        const dataCliente = await dispatch(obtenerClienteByIdLogin(solicitud.idlogin))
        let informacionmodalaceptada = {
            numerosolicitudservicios: dataForm?.numeroSolicitud, numcertificadonom: dataForm?.numCertificadoNOM,
            fechainspeccion: dataForm?.fechaInspeccion, numeroplanevaluacion: dataForm?.numeroPlanEvaluacion,
            inspectorasignado: dataForm?.inspectorAsignado, credencialinspector: dataForm?.credencialInspector,
            telefonoinspector: dataForm?.telefonoInspector
        }
        let modal = { idfc08_renvacioncertificado: solicitud.idfc08_renvacioncertificado, informacionmodalaceptada: informacionmodalaceptada }
        await (dispatch(actualizarFC_08SolicitudFomulario(modal)))
        await generarOficios(solicitud, dataCliente.payload.cliente[0], dataForm)

        const idSolicitud = solicitud.idfc08_renvacioncertificado
        const estatusNuevo = 4
        const idCliente = null //Se necesita obtener del cliente, a traves del login 
        const tablaFC_08 = 3
        const tabla = tablaFC_08
        await dispatch(actualizarFC_08Estatus(
            { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: solicitud.folio } }
        ))
        const idRol = currentUser.user[0].rol
        if (idRol === 1) await dispatch(obtenerTodasLasSolicitudesWithStatusEnviado({ status: 4 }))
        else if (idRol === 2) await dispatch(obtenerTodasLasSolicitudesEjecuctivoWithStatusEnviado({ status: 4, revisor: dataUser[0]?.datoslogin.nombre + ' ' + dataUser[0]?.datoslogin.apellidos, idLogin: currentUser.user[0].id }))
        await dispatch(actualizarLoadingApp_false())
        props.history.push('/AtencionAClientesComponent')
    }
    const generarOficios = async (solicitudFC_08, dataCliente, dataForm) => {
        const data = {
            tipoSolicitud: 'FC_08',
            solicitudFC_08,
            dataCliente,
        }
        let filtroGranel = solicitudFC_08.fc_08_anexocertificados.filter(filtro => filtro.tipocertificado == 'Granel')
        let filtroExportacion = solicitudFC_08.fc_08_anexocertificados.filter(filtro => filtro.tipocertificado == 'Exportacion')
        let filtroPromocion = solicitudFC_08.fc_08_anexocertificados.filter(filtro => filtro.tipocertificado == 'Exportacion promocion')
        let servicio = ''
        if (filtroGranel.length > 0) servicio = 'Renovación de certificado a granel'

        if (filtroExportacion.length > 0 && filtroPromocion.length > 0) servicio = 'Renovación de certificado de exportación y Renovación de certificado de exportación para promoción'
        else if (filtroExportacion.length > 0 && filtroPromocion.length <= 0) servicio = 'Renovación de certificado de exportación'
        else if (filtroExportacion.length <= 0 && filtroPromocion.length > 0) servicio = 'Renovación de certificado de exportación para promoción'

        const dataSolicitudInspeccion = {
            numeroSolicitud: dataForm.numeroSolicitud,
            numCertificadoNOM: dataForm.numCertificadoNOM,
            numeroTraslado: dataForm.numeroTraslado,
            otrosServicios: servicio,
            fechaInspeccion: dataForm.fechaInspeccion,
            numeroPlanEvaluacion: dataForm.numeroPlanEvaluacion,
            inspectorAsignado: dataForm.inspectorAsignado,
            credencialInspector: dataForm.credencialInspector,
            telefonoInspector: dataForm.telefonoInspector,
            checkFabrica: false,
            checkProductor: false,
            checkNacional: false,
            checkEnvasadora: false,
            checkEnvasador: false,
            checkExportacion: false,
            checkGranel: false,
            checkComercializador: false,
            checkPromocion: false,
            checkProductoTerminado: false,
            checkTraslado: false,
            checkMaduracion: false,
        }
        data.dataSolicitudInspeccion = dataSolicitudInspeccion
        await dispatch(generarDocumentosFC_08(data))
    }

    const [detalleMotivo, setDetalleMotivo] = React.useState(false)
    const [dataDetalle, setDataDetalle] = React.useState([])
    const VerModalDetalle = (objeto) => {
        setDetalleMotivo(objeto)
    }
    const [openModalDevolver, setOpenModalDevolver] = React.useState(false);
    const handleOpenModalDevolver = (params) => {
        setOpenModalDevolver(true)
    }
    const handleCloseModalDevolver = () => {
        setOpenModalDevolver(false)

    }
    const modalComponentDevolver = () => {
        return (
            <div>
                <Modal
                    open={openModalDevolver}
                    onClose={handleCloseModalDevolver}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    hideBackdrop={true}
                >
                    <Box sx={styleDevolver}>

                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            <center>¡Advertencia!</center>
                        </Typography>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }}>
                            <p>Está a punto de devolver esta solicitud.
                                Las observaciones serán enviadas al cliente para correcciones.</p>
                            <br /> <center><strong>¿Desea continuar?</strong></center>
                        </Typography>
                        <br />

                        <div className='row'>
                            <div className='col-md-6'>
                                <button className='btn btn-outline-success' onClick={() => { botonDevolverSolicitud() }}>CONTINUAR</button>
                            </div>
                            <div className={` col-md-2`}>
                                <button className='btn btn-outline-danger' onClick={() => { handleCloseModalDevolver() }}>CANCELAR</button>
                            </div>
                        </div>

                    </Box>
                </Modal>
            </div>
        )
    }
    return (
        <Fragment>
            <div className='text-center'>
                <PaginacionAtencionAClientesComponent paginas={paginas} nombreParaPaginas={nombresParaPaginas} paginaActiva={paginaActiva} cambiarPagina={cambiarPagina} />
            </div>
            {
                nombresParaPaginas[paginaActiva - 1] === 'Datos solicitante' ?
                    <div className='row justify-content-center'>
                        <div className='col-10'>
                            <TablaAtencionACliente rows={rowspagina1} api={{ handdleEditPrev }}></TablaAtencionACliente>
                        </div>
                    </div> :
                    nombresParaPaginas[paginaActiva - 1] === 'Certificados' ?
                        <div className='row justify-content-center'>
                            <div className='col-9' >
                                <div style={{ height: (130 + (rowspagina2?.length * 50)), width: '100%', color: 'black' }}>
                                    <DataGrid
                                        rows={rowspagina2}
                                        columns={columns}

                                        sx={{
                                            boxShadow: 0,
                                            color: 'black',
                                            border: 0,
                                            '& .MuiDataGrid-cell': {
                                                display: 'block',
                                                position: 'relative',
                                                textAlign: 'center',
                                            },
                                        }}
                                    />
                                </div>
                            </div>
                        </div> :
                        nombresParaPaginas[paginaActiva - 1] === 'Documentación' ?
                            <Fragment>
                                <div className='row justify-content-center'>
                                    <div className='col-12' style={{ marginLeft: '7%' }}>
                                        <TablaDocumentacion rows={rowspagina4} api={{ handdleEditPrev }}></TablaDocumentacion>
                                    </div>
                                </div>
                                {modoVerDetalle ?
                                    <div className="row text-center">
                                        <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                            <button type="submit" className={`btn ${estilos.botonNaranjaRedondo}`} onClick={botonRegresar} >Regresar</button>
                                        </div>
                                    </div>
                                    :
                                    <div className="row text-center mt-4 mb-4">
                                        <div className='col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                            <button type="submit" className={`btn ${estilos.botonNaranjaRedondo}`} onClick={handleOpenModalAceptar} >Aceptar solicitud</button>
                                        </div>

                                        <div className='col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                            <button type="submit" className={`btn ${estilos.botonNaranjaRedondo}`} onClick={handleOpenModalDevolver} >Devolver solicitud</button>
                                        </div>
                                    </div>
                                }
                            </Fragment>
                            : ''
            }
            {modalComponentCorrecto()}
            {modalComponentIncorrecto()}
            {modalComponentAceptar()}
            {modalComponentDevolver()}
            {detalleMotivo && <ModalDetalleMotivos api={{ VerModalDetalle, dataDetalle, detalleMotivo }} />}
        </Fragment>
    )
}

export default withRouter(FC_08Component)
